import { Navigate } from 'react-router-dom';
import preloadChunks from '@/routes/preloadChunks.util';
import Signings from '@/pages/Signings';

const editRoutes = [
  {
    path: ':workflowId',
    lazy: async () => ({
      Component: (await preloadChunks['signings.workflow']()).default,
    }),
  },
];

const detailRoute = {
  path: 'signings/:workflowId/report',
  lazy: async () => ({
    Component: (await preloadChunks['signings.detail']()).default,
  }),
  children: [
    { index: true, element: <Navigate to="summary" replace /> },
    {
      path: 'summary',
      lazy: async () => ({
        Component: (await preloadChunks['signings.report.summary']()).default,
      }),
    },
    {
      path: 'auditTrail',
      lazy: async () => ({
        Component: (await preloadChunks['signings.report.auditTrail']())
          .default,
      }),
    },
  ],
};

const signingsRoutes = [
  detailRoute,
  {
    path: 'signings',
    element: <Signings />,
    children: editRoutes,
  },
  {
    path: 'signings/draft',
    element: <Signings filter="draft" />,
    children: editRoutes,
  },
  {
    path: 'signings/pending',
    element: <Signings filter="pending" />,
    children: editRoutes,
  },
  {
    path: 'signings/done',
    element: <Signings filter="done" />,
    children: editRoutes,
  },
  {
    path: 'signings/expired',
    element: <Signings filter="expired" />,
    children: editRoutes,
  },
  {
    path: 'signings/cancelled',
    element: <Signings filter="cancelled" />,
    children: editRoutes,
  },
];

export default signingsRoutes;
